<template>
    <div class="common-container accent-container">
        <v-container fluid style="height: 100%; width: 85%;">
            <v-layout class="pt-4 pb-4" row style="height: 100%;">
                <v-flex xs5 class="pl-4 pr-4 mt-4 pb-4">
                    <v-card class="mx-auto card-shadows">
                        <v-card-text class="blue-title">
                            <v-card-title class="headline pt-2 pb-2">Accent Test</v-card-title>
                            <p class="accent-tips">Please click [start recording] and read out the sentence in the right box. After reading, click [submit response] to enter the next question.</p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs5 class="pl-4 pr-4 mt-4 pb-4">
                    <v-card class="mx-auto card-shadows">
                        <v-card-text class="blue-title">
                            <v-card-title class="headline pt-2 pb-2">Operate</v-card-title>
                            <p class="accent-tips">{{currentSentence ? currentSentence.Sentence : ''}}</p>
                        </v-card-text>

                        <div class="accent-detail pt-5 blue-title">
                            <v-progress-linear :value="progressBarValue" height="15" color="teal lighten-1"></v-progress-linear>
                            <div class="accent-record-time pb-4">{{ recordTime }}</div>
                            <div class="accent-recorder" v-if="!isRecording && !reRecording">
                                <a class="start-answer" title="Start Recording" href="javascript:;" @click="startRecording"></a>
                                <p>Start Recording</p>
                            </div>
                            <div class="accent-recorder" v-if="isRecording && !reRecording">
                                <a class="start-answer stop" :class="!leastTimeFlag ? 'dis-stop' : ''" title="Submit Response"  href="javascript:;" @click="stopRecording"></a>
                                <p>Submit Response</p>
                            </div>
                            <div class="accent-recorder" v-if="!isRecording && reRecording">
                                <a class="start-answer retry" title="Re recording" href="javascript:;" @click="startRecording('retry')">
                                    <i class="material-icons">replay</i>
                                </a>
                                <p>Re recording</p>
                            </div>
                            <div class="accent-recorder pb-3" v-if="!isRecording && reRecording">
                                <v-btn class="text-none red-button height-28" @click="submitResponse()" :loading="accentLoading">Submit Response</v-btn>
                            </div>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex xs1 class="pl-4 pr-4 mt-4 pb-4">
                    <v-card class="mx-auto card-shadows pt-4">
                         <div class="question-column">
                            <ul>
                                <li data-num="1" :class="currentSentenceNumber === 0 ? 'current': '' || currentSentenceNumber > 0 ? 'answered' : 'noAnswer'"><span>1</span></li>
                                <li data-num="2" class="noAnswer" :class="currentSentenceNumber === 1 ? 'current': '' || currentSentenceNumber > 1 ? 'answered' : 'noAnswer'"><span>2</span></li>
                                <li data-num="3" class="noAnswer" :class="currentSentenceNumber === 2 ? 'current': '' || currentSentenceNumber >= 2 ? 'answered' : 'noAnswer'"><span>3</span></li>
                            </ul>
                        </div>
                    </v-card>
                </v-flex>
                
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { Recorder } from '@/utils/recorder/recorder-mp3'
import { getAccentList, uploadAccentSentence, getTotalScore } from '@/api/accentTest.js'
import { mapGetters } from 'vuex'

export default {
    // props:["constractView"],
    data: ()=>({
        isRecording: false, //是否正在录音 
        reRecording: false,  // 重录
        progressBarValue: 0, //进度条进度 
        recordTime: '00:00', //倒计时时间
        setUpTimer: null, //计时器
        _recorder: null, 
        accentSentenceList: [],
        currentSentence: null,
        currentSentenceNumber: -1,
        leastTimeFlag: false, //最小录音时长(3秒)
        accentLoading: false
    }),
    computed: {
      ...mapGetters([
        'user'
      ])
    },
    methods:{
        getAccentTestList() { //获取语音题目
            getAccentList(this.user.tuid).then(res => {
                let dataList = res.data.Body
                if(!dataList.length) {
                    getTotalScore(this.user.tuid).then(res => {
                        let result = res.data
                        if (result.ErrorCode === 0) {
                            let res = ['American accent', 'British accent', 'Filipino accent']
                            this.$toasts(res[result.Body-1], 'accentTest')
                        }else{
                            this.$root.$alertTips(result.Msg)
                        }
                    })
                    this.currentSentence = []
                    this.currentSentenceNumber = -1
                    this.isRecording = true 
                    this.reRecording = false
                    this.leastTimeFlag = false
                    this.initRecordBar()
                }else{
                    this.accentSentenceList = dataList
                    this.currentSentence = this.accentSentenceList[0]
                    this.currentSentenceNumber = 0
                    this.isRecording = false 
                    this.reRecording = false
                    this.initRecordBar()
                }
            })
        },
        getTotalScore() {
             getTotalScore(this.user.tuid).then(res => {
                let result = res.data
                if (result.ErrorCode === 0) {
                    let res = ['American accent', 'British accent', 'Filipino accent']
                    this.$toasts(res[result.Body-1], 'accentTest')
                    this.getAccentTestList() //刷新题目，重置状态
                    // this.isRecording = false 
                    // this.reRecording = false
                    // this.initRecordBar()
                }else{
                    this.$root.$alertTips(result.Msg)
                }
                
            })
        },
        startRecording(type) {
            if(!this._recorder) {
                this.$toasts('Please allow the browser to use the microphone!', 'lotteryWarning') //警告
                return
            }
            if(this.accentLoading) {
                return
            }
            if(type === 'retry'){
                this.reRecording = false
            }
            this.isRecording = true
            this.initRecordBar()
            this.recordTimer()
            this.startRecorder()
            
            setTimeout(() => {
                this.leastTimeFlag = true
            }, 3000); //最少录制3秒
        },
        stopRecording() {
            if(!this.leastTimeFlag) {
                return
            }
            this.isRecording = false
            this.reRecording = true
            this.leastTimeFlag = false
            this.stopRecorder()
        },
        submitResponse(){
            this.accentLoading = true
            this.createDownloadLink()
        },
        recordTimer: function (questionNum) {
            let time = 60;
            clearInterval(this.setUpTimer)
            let t = 0;
            this.setUpTimer = setInterval(() => {
                if (this.isRecording) {
                    time--
                    t++
                    let totalTime = 60;
                    let progressWidth = 100 - parseInt((time / totalTime) * 100)
                    this.progressBarValue = progressWidth
                    this.recordTime = this.formatSeconds(t)
                    if (time <= 0) {
                        clearInterval(this.setUpTimer)
                        this.stopRecording()
                    }
                } else {
                    clearInterval(this.setUpTimer)
                }
            }, 1000)

        },
        formatBit(val) {
            val = +val
            return val > 9 ? val : '0' + val
        },
        formatSeconds(time) {
            let min = Math.floor(time % 3600)
            let val = this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60)
            return val
        },
        initRecorderPlug: function (stream) {   //初始化recorder
            this._recorder = new Recorder({
                sampleRate: 44100, //采样频率，默认为44100Hz(标准MP3采样率)
                bitRate: 128, //比特率，默认为128kbps(标准MP3质量)
                success: function () { //成功回调函数
                    console.log("Recorder success");
                },
                error: function (msg) { //失败回调函数
                    console.log("Recorder error", msg);
                },
                fix: function (msg) { //不支持H5录音回调函数
                    console.log("Recorder fix", msg);
                }
            });
        },
        startRecorder() {
             this._recorder.start();
        },
        stopRecorder() {
            this._recorder.stop();
        },
        //创建下载
        createDownloadLink: function (questionNum) {

            //audio/mp3
            let that = this 
            this._recorder.getBlob(function (blob) {
                that.saveAnswer(blob)
            })
        },
        saveAnswer(data) {
            var formData = new FormData()
            formData.append('Voice', data)

            uploadAccentSentence(this.user.tuid, this.currentSentence.SentenceId, formData).then(res => {
                let result = res.data
                if (result.ErrorCode === 0) {

                    this.accentLoading = false
                    if(this.currentSentenceNumber === 0 || this.currentSentenceNumber === 1) {
                        this.$root.$alertTips('Coming to the next question', 'success')
                        this.nextSentence()
                    }else if(this.currentSentenceNumber === 2){
                        this.getTotalScore()
                    }
                
                }else{
                    if(result.ErrorCode === -2){ //无声音
                        this.$root.$alertTips('There is no sound, please record again!')
                    }else{
                        this.$root.$alertTips(result.Msg)
                    }
                    this.accentLoading = false
                }
            })

        },
        nextSentence() { //下一题
            if(this.currentSentenceNumber >= 2){
                return
            }
            this.currentSentenceNumber ++
            this.currentSentence = this.accentSentenceList[this.currentSentenceNumber]
            this.isRecording = false
            this.reRecording = false
            this.initRecordBar()
            
        },
        initRecordBar() {
            this.progressBarValue = 0
            this.recordTime = "00:00"
        }
    },
    mounted(){
        this.$nextTick(() => {
            try {
                console.log(navigator);
                
                if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    console.log(11);
                    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                       this.initRecorderPlug()
                    },errBack =>{
                        console.log(errBack);
                    });
                }
                else if(navigator.getUserMedia) { // Standard
                    console.log(22);
                    navigator.getUserMedia({ audio: true }, stream => {
                        this.initRecorderPlug()
                    }, errBack =>{
                        console.log(errBack);
                    });
                } else if(navigator.webkitGetUserMedia) { // WebKit-prefixed
                    console.log(33);
                    navigator.webkitGetUserMedia({ audio: true }, stream =>{
                       this.initRecorderPlug()
                    }, errBack =>{
                        console.log(errBack);
                    });
                } else if(navigator.mozGetUserMedia) { // Mozilla-prefixed
                    console.log(44);
                    navigator.mozGetUserMedia({ audio: true }, stream =>{
                        this.initRecorderPlug()
                    }, errBack =>{
                        console.log(errBack);
                    });
                } else {
                    console.log(55);
                    alert('No web audio support in this browser!!');
                }

            } catch (e) {
                alert('No web audio support in this browser!');
            }
            
        })
        this.getAccentTestList()
    }

}
</script>
<style lang="scss" scoped>
.accent-container{
    min-height: calc(100vh - 50px);
    height: calc(100vh - 50px);
}
.card-shadows{
    height: 100%;
    box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19);
    border-radius: 8px;
}
.accent-tips{
    font-size: 16px;
    line-height: 30px;
    padding: 16px;
    padding-bottom: 0;
}
.accent-detail{
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
    .v-progress-linear{
        background: #e9ecef;
        border-radius: 5px;
        .v-progress-linear__bar__determinate{
            background: $blue-title;
        }
    }
    .accent-record-time{
        color: $blue-title;
    }
    .accent-recorder{
        
        .start-answer{
            border: 2px solid $blue-title;
            width: 50px;
            border-radius: 50%;
            height: 50px;
            background: #fff;
            position: relative;
            display: inline-block;
            &:after{
                content: '';
                position: absolute;
                width: 23px;
                height: 23px;
                background: $pink-btn-background;
                border-radius: 50%;
                left: 0;
                margin-left: 11px;
                top: 0;
                margin-top: 12px;
            }
            
        }
        // .v-btn.theme--light {
        //     background-color: #fff!important;
        //     color: #26a69a;
        //     border-color: #26a69a!important;
        //     border-style: solid;
        //     border-radius: 7px;
        //     border-width: 1px;
        // }
        .height-28{
            height:28px
        }
        .start-answer.stop {
                &:after {
                    border-radius: 0;
                }
            }

            .start-answer.stop.dis-stop {
                &:after {
                    background: gray;
                }
            }

            .start-answer.retry {
                &:after {
                    content: none
                }
                .material-icons{
                    margin-top: 7px;
                    font-size: 30px;
                    color: #3e67fb;
                }
            }
    }
}
.question-column{
    ul {
            padding: 0;

            li {
                height: 1.8rem;
                width: 1.8rem;
                margin: 0 auto;
                margin-bottom: 1.5rem;
                // cursor: pointer;
                list-style: none;
                color: $blue-title;
                span {
                    background: none;
                    width: 2rem;
                    height: 2rem;
                    line-height: 1.8rem;
                    position: static;
                    display: inline-block;
                    color: $blue-title;
                    border: 1px solid $blue-title;
                    text-align: center;
                    border-radius: 50%;
                }
            }

            li.current {
                span {
                    background: none;
                    color: $blue-title-2;
                    border: 2px solid $blue-title-2;
                }
            }

            li.answered {
                span {
                    background-color: $blue-title;
                    color: #fff;
                    border: 0;
                    line-height: 2.2rem;
                }
            }
        }
}
</style>